import React from 'react';
import AudioPlayer from '../../components/AudioPlayer/AudioPlayer';

type Props = {
  voops: any[];
};

function VoopsTab({voops}: Props) {
  return (
    <div className="w-1/2 px-5">
      <h2 className="pt-4 pb-4">My Voops ({voops.length})</h2>
      <div>
        {voops.map((voop: any) => {
          return (
            // todo might want to scrub the uuid?
            <div key={voop.uuid}>
              <AudioPlayer
                recording={`https://voop-${process.env.REACT_APP_APP_ENV}-audio.s3.eu-west-2.amazonaws.com/${voop.filename}`}
              />
              <p className="text-sm pt-4 pl-4">
                Transcription: {voop.transcription}
              </p>
              <p className="text-sm pb-6 pl-4">
                Sentiment: {voop.sentiment.Sentiment}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default VoopsTab;
